import { Fragment, useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { connect } from 'react-redux';
import { apiEndpoint } from './constants/api';
import Modal from './components/Modal';
import JobCandidateTable from './components/JobCandidateTable';
import { avatar } from './constants/Avatar';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import Nav from './components/Nav';


const connector = connect((state, ownProps) => ({ 
 ...state.user,
 employer: state.user.currentEmployer
}), {});

function Profile({ user, employer }) {
  const [userData, setUserData] = useState({});
  const [userRole, setUserRole] = useState('');
  const [isOpened, setIsOpened] = useState(false);
  const { id } = useParams();

  const loadUserData = async (q) => {
    const { data } = await axios.post(apiEndpoint(`/admin/user/${user.id}`));
  };

  const updateUserRoles = async () => {
    const { data } = await axios.post(apiEndpoint(`/admin/userRoles/${user.id}`), {
      userRole,
    });
    closeModal();
  };

  const closeModal = async () => {
    loadUserData();
    setIsOpened(false);
  };

  const openModal = async () => {
    loadUserData();
    setIsOpened(true);
  };

  useEffect(() => {
    loadUserData();
  }, []);

  return (
    <>
    <Helmet>
      <title>My Profile | Productions.com</title>
    </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header publicId={employer.logo} />
          <Aside />
          <main className="p-4 sm:ml-64">
            <div className="mx-auto sm:px-6 lg:px-8">
              {/* Replace with your content */}
              <div>
                <div className="w-full mb-2 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">
                  <div className="flex gap-4">
                    <div className="flex items-center">
                      {avatar(user.photo, userData.gender)}
                    </div>
                    <div>
                      <div>
                        <h1 className="text-4xl text-gray-800">
                          {user.first_name} { user.last_name}
                        </h1>
                      </div>
                      <div className="text-lg">{user.email}</div>
                    </div>
                    <div className="grow flex-col">
                      { employer && employer.value === '35d42b9e-e2f5-4070-8827-535eceb8ff12' ? <div className="flex justify-end">
                        <button
                          onClick={() => openModal()}
                          type="button"
                          className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                        >
                          Edit
                        </button>
                      </div> : <></>
                      }
                    </div>
                  </div>
                  <div className="text-2xl">{user.description}</div>
                  <div className="py-4">
                    <div>
                      <div className="text-md">
                        <b className="text-xl">Gender: </b>
                        {user.gender}
                      </div>
                      <div className="text-md">
                        <b className="text-xl">DoB: </b>
                        {user.dob}
                      </div>
                      <div className="text-md">
                        <b className="text-xl">Years of Exp.: </b>
                        {user.years_of_experience}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /End replace */}
            </div>
            <Modal
              title="Edit User"
              isOpened={isOpened}
              onClose={closeModal}
            >
              <form className="my-10">
                <div className="text-lg text-left">
                  {' '}
                  {userData.first_name} {userData.last_name}
                </div>
                <p>Update the Available Employers</p>
                <select
                  size="5"
                  id="candidateStatus"
                  value={userRole}
                  onChange={({ target }) => setUserRole(parseInt(target.value))}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option value={0}>Choose status</option>
                  <option value={1}>Productions.com Admin</option>
                  <option value={2}>Admin</option>
                </select>
                <div className="my-2">
                  <button
                    type="button"
                    onClick={() => updateUserRoles()}
                    className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                  >
                    Update User Role
                  </button>
                  <button
                    type="button"
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(Profile);